(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7135],{

/***/ 59684:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thi-gplx/[type]",
      function () {
        return __webpack_require__(99429);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 99429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Index; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/Page.js
var Page = __webpack_require__(82771);
// EXTERNAL MODULE: ./src/hooks/useLocales.js + 5 modules
var useLocales = __webpack_require__(9671);
// EXTERNAL MODULE: ./src/layouts/index.js + 21 modules
var layouts = __webpack_require__(85307);
// EXTERNAL MODULE: ./src/sections/gplx/HomeCar.js + 2 modules
var HomeCar = __webpack_require__(52584);
// EXTERNAL MODULE: ./src/sections/gplx/HomeMotoBike.js + 2 modules
var HomeMotoBike = __webpack_require__(74445);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./src/utils/axios.js
var axios = __webpack_require__(92369);
;// CONCATENATED MODULE: ./src/service/gplx.licenseType.service.js



var findLicenseTypesAPI = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
        var config;
        return (0,tslib_es6.__generator)(this, function(_state) {
            config = {
                url: "/license-type/search",
                method: "POST",
                data: data
            };
            return [
                2,
                (0,axios/* handleRequest */.X)(config)
            ];
        });
    });
    return function findLicenseTypesAPI(data) {
        return _ref.apply(this, arguments);
    };
}();
var getLicenseTypeBySlugAPI = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(slug) {
        var config;
        return (0,tslib_es6.__generator)(this, function(_state) {
            config = {
                url: "/license-type/slug/".concat(slug),
                method: "GET"
            };
            return [
                2,
                (0,axios/* handleRequest */.X)(config)
            ];
        });
    });
    return function getLicenseTypeBySlugAPI(slug) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/utils/licenses.js
var licenses = __webpack_require__(50168);
;// CONCATENATED MODULE: ./src/pages/thi-gplx/[type]/index.js
/* eslint-disable react/prop-types */ 







Index.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts/* default */.Z, {
        variant: "main",
        children: page
    });
};
var __N_SSG = true;
function Index(param) {
    var type = param.type, licenseTypes = param.licenseTypes;
    var translate = (0,useLocales/* default */.Z)().translate;
    if (type === licenses/* licenseDataArray.4.0 */.J[4][0]) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
        title: translate("car.title"),
        description: translate("car.description"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeCar/* default */.Z, {
            licenseTypes: licenseTypes
        })
    });
    else return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
        title: translate("bike.title"),
        description: translate("bike.description"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeMotoBike/* default */.Z, {
            licenseTypes: licenseTypes
        })
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5101,1160,3362,6093,3559,1553,7207,9774,2888,179], function() { return __webpack_exec__(59684); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);